import React, { useContext, useEffect, useState } from 'react';
import { View, StyleSheet, Text, Image } from 'react-native';
import Popup from 'reactjs-popup';
import { Checkbox, List, Searchbar } from 'react-native-paper';
import { ColumnKey } from '@zonofi/seller-rtk-store';
import { colors } from '../colors/colors';
import { SHARED_SVGS } from '../assets';
import { ThemeContext } from '../contexts/ThemeContext';

/* eslint-disable-next-line */
export interface ColumnFilterProps {
  columns: any[];
  setColumns?: (val: { key: ColumnKey; value: boolean }) => void;
  iconSize?: number;
}

export const ColumnFilter: React.FC<ColumnFilterProps> = ({
  columns,
  setColumns,
  iconSize = 30,
}) => {
  const [searchInput, setSearchInput] = useState('');
  const [initialColumns, setInitialColumns] = useState(columns);
  const [filteredItems, setFilteredItems] = useState<any[]>([]);
  const currentTheme = useContext(ThemeContext);
  const { theme } = currentTheme;
  const [highlight, setHighlight] = useState(false);

  const hanldeSearchInput = (val: any) => {
    const filtered = columns.filter((item: any) =>
      item.name.toLowerCase().includes(val.toLowerCase())
    );
    setFilteredItems(filtered); // ts error needs to be taken care
    setSearchInput(val);
  };

  const handleCheckBoxStatus = (itemId: ColumnKey) => {
    setColumns && setColumns({ key: itemId, value: true });
  };

  useEffect(() => {
    const filtered = initialColumns.filter((item: any) =>
      item.name.toLowerCase().includes(searchInput.toLowerCase())
    );
    setFilteredItems(filtered); // ts error needs to be taken care
  }, [initialColumns]);

  useEffect(() => {
    setInitialColumns(columns);
  }, [columns]);

  return (
    <Popup
      position={'bottom right'}
      onOpen={() => setHighlight(true)}
      onClose={() => setHighlight(false)}
      trigger={
        <View
          style={[
            styles.icon,
            highlight
              ? theme.filterButton.selected
              : theme.filterButton.unselected,
          ]}
        >
          <Image
            source={{ uri: SHARED_SVGS.CustomColumns }}
            style={{ width: iconSize, height: iconSize }}
          />
        </View>
      }
    >
      <div
        style={{
          ...styles.container,
          backgroundColor: theme?.communication?.sideListBackground,
          borderColor: theme.columnFilter.border,
          maxHeight: '50vh',
          overflowY: 'scroll',
        }}
      >
        <List.Item
          title={
            <Text
              style={[
                { ...theme.fontConfig.semiBold },
                {
                  color: colors.manatee.color,
                  fontSize: 13,
                },
              ]}
            >
              CUSTOM COLUMNS
            </Text>
          }
        />

        <Searchbar
          placeholder="Search"
          onChangeText={(val) => {
            hanldeSearchInput(val);
          }}
          value={searchInput}
          style={[
            styles.filterSearch,
            {
              backgroundColor: theme.dropDown.background,
              borderColor: theme.columnFilter.border,
            },
          ]}
          clearIcon={() => {
            return null;
          }}
          iconColor={colors.manatee.color}
          inputStyle={[
            styles.filterSearchInputStyle,
            { color: theme.text.primary },
          ]}
        />
        {filteredItems &&
          filteredItems.map((item: any) => {
            const itemId = item.key;
            return (
              <List.Item
                key={itemId}
                title={
                  <Text
                    style={[
                      {
                        color: theme.text.primary,
                        display: 'flex',
                        alignItems: 'center',
                      },
                    ]}
                    onPress={() => {
                      handleCheckBoxStatus(itemId);
                    }}
                  >
                    {item.name}
                  </Text>
                }
                left={() => (
                  <Checkbox
                    color={item.isDefault}
                    status={item.isVisible ? 'checked' : 'unchecked'}
                    onPress={() => {
                      handleCheckBoxStatus(itemId);
                    }}
                  />
                )}
              />
            );
          })}
      </div>
    </Popup>
  );
};

const styles = StyleSheet.create({
  columnFilterButton: {
    // borderRadius: 6,
    // paddingVertical: 40,
    // paddingHorizontal: 20,
    // flexDirection: 'row',
    // justifyContent: 'space-between',
    // height: 42,
    // width: 99,
    // alignItems: 'center',
  },
  container: {
    borderRadius: 6,
    // paddingHorizontal: 10,
    paddingBottom: 15,
    // width: 250,
    borderWidth: 1,
  },
  listItems: {
    height: '100%',
    // overflow: 'scroll',
  },
  filterSearch: {
    width: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderStyle: 'solid',
  },
  icon: {
    borderRadius: 6,
    borderWidth: 1,
  },
  filterSearchInputStyle: {},
  // filterHeaderText: {
  //   fontWeight: '800',
  //   fontFamily: 'Fira Sans',
  // }
});

export default ColumnFilter;
